import { SKU } from './SKU'

export class Modifier {
    constructor(
        public id: string,
        public displayName: string,
        public description: string | null,
        public skus: SKU[]
    ) {}
}

export class ModifierGroup {
    constructor(
        public id: string,
        public name: string,
        public minimumModifiersRequired: number | null,
        public maximumModifiersRequired: number | null,
        public modifiers: Modifier[]
    ) {}
}
